export default __webpack_public_path__ + "90de8805aa74560f3e0eee3844a178ec.png";